// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"6bee3994","202":"bc4f224e","608":"90718454","681":"f75e1013"}[chunkId] + ".css";
};